import { Link } from "react-router-dom";

export default function ProductCard({ product }) {
  return (
    <Link
      to={`/product/${product.id}`}
      className="group flex flex-col gap-4"
      data-testid={`product-card-${product.id}`}
    >
      <div className="relative aspect-[4/5] bg-[#f5f5f5] overflow-hidden">
        <img
          src={product.image_url}
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
      </div>
      <div className="flex flex-col gap-1">
        <div className="text-[10px] uppercase tracking-[0.22em] text-[#666]">
          {product.category}
        </div>
        <div className="text-base font-medium">{product.name}</div>
        <div className="text-sm text-[#666]">₹{product.price.toFixed(2)}</div>
      </div>
    </Link>
  );
}
